import { ReactElement, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Form, FormGroup, TextFieldController } from 'components';
import { pillFieldSx } from 'features/auth/containers/SignInForm/styles';
import { WranDescription } from 'features/companyRegistration/components/RegisterCompanyForm/styled';
import { Links } from 'settings';
import { PasswordResetFormValues } from 'types';

import { emailFieldRules } from './rules';
import { FooterW, LinkW, ResetPasswordButton, SignUpHint } from './styled';
import { useRestorePasswordForm } from './useRestorePasswordForm';

const EMAIL_MAX_LENGTH = 254;

interface PasswordResetFormProps {
  setEmail: (email: string) => void;
  isLoading: boolean;
  requestPasswordResetMutation: (data: PasswordResetFormValues) => void;
}

export function PasswordResetForm({
  setEmail,
  requestPasswordResetMutation,
}: PasswordResetFormProps): ReactElement {
  const [emailExist, setEmailExist] = useState<boolean>(true);
  const { control, handleFormSubmit } = useRestorePasswordForm({
    setEmail,
    setEmailExist,
    requestPasswordResetMutation,
  });
  const { t } = useTranslation();

  return (
    <Form sx={{ marginTop: '32px' }} onSubmit={handleFormSubmit}>
      <FormGroup>
        <TextFieldController
          name="email"
          id="email"
          control={control}
          type="email"
          label={t('restorePassword.form.label')}
          placeholder={t('restorePassword.form.label')}
          rules={emailFieldRules}
          maxLength={EMAIL_MAX_LENGTH}
          sx={pillFieldSx}
        />
      </FormGroup>
      {!emailExist && <WranDescription>{t('restorePassword.errorMessage')}</WranDescription>}
      <FooterW>
        <ResetPasswordButton type="submit" variant="contained" color="info">
          {t('restorePassword.sendButton')}
        </ResetPasswordButton>
      </FooterW>
      <SignUpHint sx={{ marginTop: '20px' }}>
        <Trans i18nKey="login.noAccount" values={{ linkLabel: t('signUp.signUpBtn') }}>
          Don&apos;t have an account?
          <LinkW to={Links.auth.registration.index}>{t('signUp.signUpBtn')}</LinkW>
        </Trans>
      </SignUpHint>
    </Form>
  );
}
